import * as React from 'react';

import { ObjectStatus, StageStatus } from 'features/search/filters/enums';

import './_statusTag.scss';
import { FormattedMessage } from 'react-intl';
import { ResidenceCardType } from '.';
import { TagColor, Tags, TagDesign } from '@atoms/Tags/Tags';

interface Props {
    status: StageStatus | ObjectStatus;
    cardType: ResidenceCardType;
    purchase?: boolean;
}

export const StatusTag: React.FunctionComponent<Props> = ({status, cardType, purchase}) => {
    const getText = () => {
        if(purchase) return <FormattedMessage id='jm.components.ResidenceTags.isPurchase' />;

        switch (status) {
            //Dessa har samma enum
            case ObjectStatus.PRESELLING:
            case StageStatus.PRESELLING:
                return (cardType === ResidenceCardType.OBJECT
                    ? <FormattedMessage id='jm.components.ResidenceTags.sellingObject' />
                    : <FormattedMessage id='jm.components.ResidenceTags.preSelling' />);

            default: 
                return null;
        }
    };

    const getColor = () => {
        if(purchase) return TagColor.GREEN;

        switch (status) {
            //Dessa har samma enum
            case ObjectStatus.PRESELLING:
            case StageStatus.PRESELLING:
                return cardType === ResidenceCardType.OBJECT
                    ? TagColor.GREEN
                    : TagColor.YELLOW;

            default: 
                return;
        }
    };

    return (
        <Tags 
            tagDesign={TagDesign.DEFAULT} 
            tagColor={getColor()} 
            tagText={getText()} 
            status={status} 
            className='status-tag'
        />
    );
};